import fetch from "isomorphic-fetch";
import { fetchParameters } from "./fetchParameters";

function handleErrorState(e, resolve) {
  console.error(JSON.stringify(e, null, 2));
  this.props.toastContext.openToast({
    message:
      "Could not generate a quote. Please adjust your settings and try again.",
  });
  this.setState({ quotes: [] });
  this.setState({ insufficientData: true });
  resolve();
}

export function processQuoteResult(endpoint) {
  return new Promise((resolve) => {
    fetch(endpoint, fetchParameters)
      .then((response) => {
        if (response.ok) {
          response.json().then((result) => {
            if (!result.status) {
              this.setState({ quotes: result });
              this.setState({ insufficientData: false });
              resolve();
            } else {
              throw result;
            }
          });
        } else {
          throw response;
        }
      })
      .catch((e) => {
        handleErrorState.call(this, e, resolve);
      });
  });
}
